(function () {
  'use strict';

  var section = document.querySelector('[data-luxe-sub]');
  if (!section) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST || reduce) return;

    gsap.registerPlugin(ST);

    var heads = section.querySelectorAll('[data-sub-heading]');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      gsap.set(h, { clipPath: 'inset(100% 0 0 0)', opacity: 0, y: 12 });
      gsap.to(h, {
        clipPath: 'inset(0% 0 0 0)', opacity: 1, y: 0,
        duration: 1.05, ease: 'power3.out',
        scrollTrigger: { trigger: h, start: 'top 85%' }
      });
    }

    ST.refresh();
  }

  function whenReady() {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
    else init();
  }

  if (document.readyState !== 'loading') whenReady();
  else document.addEventListener('DOMContentLoaded', whenReady);
})();
